import React from "react";

const SVG = ({ width = "100%", className = "", viewBox = "0 0 30 30" }) => (
  <svg
    width={width}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ""}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <defs>
      <path
        d="m16.414 15 4.293-4.293a.999.999 0 1 0-1.414-1.414L15 13.586l-4.293-4.293a.999.999 0 1 0-1.414 1.414L13.586 15l-4.293 4.293a.999.999 0 1 0 1.414 1.414L15 16.414l4.293 4.293a.997.997 0 0 0 1.414 0 .999.999 0 0 0 0-1.414L16.414 15z"
        id="f3wdv7bgaa"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h30v30H0z" />
      <mask id="yffnzbd44b" fill="#fff">
        <use xlinkHref="#f3wdv7bgaa" />
      </mask>
      <use fill="#31373D" xlinkHref="#f3wdv7bgaa" />
      <path fill="#C1C7D0" mask="url(#yffnzbd44b)" d="M0 0h30v30H0z" />
    </g>
  </svg>
);

export default SVG;
